import { Component, EventEmitter, Output } from '@angular/core';
import { CustomModalService } from '../../../../../shared/modais/custom-modal/custom-modal.service';
import { ModalTermosComponent } from './modal-termos/modal-termos.component';

@Component({
  selector: 'app-termos',
  templateUrl: './termos.component.html',
  styleUrls: ['./termos.component.scss']
})
export class TermosComponent {

  @Output() scrEvent = new EventEmitter();
  @Output() termosDeUsoEvent = new EventEmitter();

  scr = false;
  termosDeUso = false;

  constructor(
    private modal: CustomModalService,
  ) {}

  onClickTermos(type: 'termos-de-uso' | 'scr' = 'termos-de-uso') {

    this.modal.show(ModalTermosComponent, {
      class: 'modal-lg',
      keyboard: false,
      ignoreBackdropClick: true,
      initialState: {
        type
      }
    });
  }

  emitChange(type: 'termos-de-uso' | 'scr' = 'termos-de-uso') {
    if (type === 'termos-de-uso') {
      this.termosDeUsoEvent.emit(this.termosDeUso);
    } else {
      this.scrEvent.emit(this.scr);
    }
  }
}
